import { FileFormat } from '../../shared/types/resultsDownload';

export const fileFormatsResultsDownload = [
  FileFormat.fasta,
  FileFormat.tsv,
  FileFormat.excel,
  FileFormat.json,
  FileFormat.xml,
  FileFormat.rdfXml,
  FileFormat.list,
];

export const fileFormatEntryDownload = [
  FileFormat.fasta,
  FileFormat.json,
  FileFormat.excel,
  FileFormat.xml,
  FileFormat.rdfXml,
  FileFormat.tsv,
];
